export default "__VITE_ASSET__0aa9fce3__"